import { IBaseMigrationStaffer } from '../../../interfaces';
import { StafferMappingHandler } from '../../../mappings/staff';
import {
  CorePracticeProvider,
  ICorePracticeProvider,
  ProviderSourceEntity,
} from '../../source/entities/providers';

export class CorePracticeStafferMappingHandler extends StafferMappingHandler<
  CorePracticeProvider,
  ProviderSourceEntity
> {
  override sourceEntity = new ProviderSourceEntity();
  translateFn = (record: ICorePracticeProvider): IBaseMigrationStaffer => {
    return {
      id: record.id,
      name: `${record.firstName} ${record.providerName}`,
      providerNo: record.providerNumber,
    };
  };
}
